import { useMemo } from 'react';
import { isRouteErrorResponse, useNavigate } from 'react-router-dom';
import { Button, FlosIcon } from '@flos/react-ui';

import { pages } from '../PageConfig';
import { useConfigContext } from '../context/ConfigContext';

import { useStateValue } from '../hooks/UseStateValue';
import { reset } from '../store/Actions';

type Error = {
    error: {
        status: number;
        statusText: string;
    };
};

const ErrorPage = (error: Error) => {
    const [, dispatch] = useStateValue();
    const config = useConfigContext();
    const productPages = pages[config.product];
    const navigate = useNavigate();

    const handleReset = () => {
        reset(dispatch);
        navigate(productPages[0].path);
    };

    const text = useMemo(
        () => (isRouteErrorResponse(error) ? `${error.status} ${error.statusText}` : 'Ukendt fejl'),
        [error]
    );

    return (
        <div className="page-content">
            <div style={{ textAlign: 'center', margin: '220px auto' }}>
                <FlosIcon shape="car-crash-single" size="xlarge" />
                <div style={{ margin: '20px auto', fontWeight: 600, fontSize: 20 }}>
                    Åh nej, du er havnet i en blindgyde!
                </div>
                <div style={{ margin: '30px auto', fontWeight: 500, fontSize: 15 }}>"{text}"</div>
                <Button onClick={() => handleReset()}>Start forfra</Button>
            </div>
        </div>
    );
};

export default ErrorPage;
